import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import Modal from '@/components/v3/Modal.vue';
let BusinessMessagingPromotion = class BusinessMessagingPromotion extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.requestOnProcess = false;
        this.doNotShowPopup = false;
    }
    goToInviteSubscriber() {
        this.$emit('closePopup');
        this.$router.push({
            name: 'invite-subscriber',
        });
    }
};
BusinessMessagingPromotion = __decorate([
    Component({
        components: {
            ActionButton,
            Modal,
        },
    })
], BusinessMessagingPromotion);
export default BusinessMessagingPromotion;
